/** @jsxImportSource @emotion/react */

import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { SHOW_SECRETS } from '../constants';
import specs from '../openapi.json';
import specs_with_processing from '../openapi_with_secrets.json';

export const Endpoints = () => {
  return (
    <SwaggerUI
      spec={SHOW_SECRETS ? specs_with_processing : specs}
      supportedSubmitMethods={[]}
      defaultModelsExpandDepth={-1}
      defaultModelRendering={'model'}
    />
  );
};
